import { AdvancedSVG, EvolutionSVG, MlSpaceSVG, VmwareSVG } from '@sbercloud/uikit-product-icons';

import { PLATFORMS } from '@/constant/common';

type Item = { name: string; Icon: typeof EvolutionSVG };

export const makePlatformMultiselectOptions = (metaPlatforms?: string[]): Item[] => {
  const iconByPlatformName = {
    [PLATFORMS.evolution]: EvolutionSVG,
    [PLATFORMS.advanced]: AdvancedSVG,
    [PLATFORMS.vmware]: VmwareSVG,
    [PLATFORMS.mlSpace]: MlSpaceSVG,
  };

  if (!metaPlatforms) return [];

  return metaPlatforms.map(platform => ({
    name: platform,
    Icon: iconByPlatformName[platform as keyof typeof iconByPlatformName] || null,
  }));
};
